import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * One step up in the app, with a destination label.
 * The Finlytics Forge logo is home; this button is the parent screen.
 */
const HeaderBackButton = ({ to, label }) => {
    const navigate = useNavigate();
    return (
        <button
            type="button"
            className="action-btn header-back-btn"
            onClick={() => navigate(to)}
        >
            <span aria-hidden="true">←</span>
            {label}
        </button>
    );
};

export default HeaderBackButton;
